<template>
  <streaming-line-four-dataset-chart
    ref="statsCountChart"
    :height="300"
    :chart-data="charData"
    :dataset1="fiveSecsdataset"
    :dataset2="tenSecsdataset"
    :dataset3="thirtySecsdataset"
    :dataset4="sixtySecsdataset"
    :is-started="isStarted"
    :options="chartOption"
    :time-scale="scala"
  />
</template>

<script>
import StreamingLineFourDatasetChart from '@/components/Charts/StreamingLineFourDatasetChart.js'

export default {
  components: {
    StreamingLineFourDatasetChart
  },
  props: {
    isStarted: {
      type: Boolean,
      required: true,
      default: false
    },
    fiveSecsdataset: {
      type: Array,
      required: true
    },
    tenSecsdataset: {
      type: Array,
      required: true
    },
    thirtySecsdataset: {
      type: Array,
      required: true
    },
    sixtySecsdataset: {
      type: Array,
      required: true
    },
    scala: {
      type: Number,
      required: true
    }
  },
  computed: {
    chartOption () {
      const self = this
      return {
        legend: {
          position: 'top',
          align: 'start'
        },
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              gridLines: {
                display: false
              },
              type: 'realtime',
              realtime: {
                duration: 60000,
                refresh: 50,
                delay: 10,
                pause: true
              },
              time: {
                minUnit: 'second'
              }
            }
          ],
          yAxes: [
            {
              type: 'linear',
              display: true,
              gridLines: {
                color: self.darkMode
                  ? 'rgba(0, 0, 0, 0.1)'
                  : 'rgba(100, 100, 100, 1)'
              },
              ticks: {
                maxTicksLimit: 3,
                callback: function (value) {
                  return value.toFixed(2)
                }
              }
            }
          ]
        },
        tooltips: {
          enabled: false
        },
        events: [],
        hover: {
          enabled: false
        },
        elements: {
          point: {
            radius: 0
          }
        }
      }
    },
    charData () {
      return {
        labels: [],
        datasets: [
          {
            label: this.$tc('average_unit_5'),
            fill: false,
            borderColor: '#ADD8E6',
            cubicInterpolationMode: 'monotone',
            data: []
          },
          {
            label: this.$tc('average_unit_10'),
            fill: false,
            borderColor: '#6495ED',
            cubicInterpolationMode: 'monotone',
            data: []
          },
          {
            label: this.$tc('average_unit_30'),
            fill: false,
            borderColor: '#4169E1',
            cubicInterpolationMode: 'monotone',
            data: []
          },
          {
            label: this.$tc('average_unit_60_t'),
            fill: false,
            borderColor: '#00008B',
            cubicInterpolationMode: 'monotone',
            data: []
          }
        ]
      }
    }
  }
}
</script>
